export default function useFilterDates() {
  const filterDatesToLocalString = (fromDate: Date, toDate: Date) => {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);
    return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
  };
  return {
    filterDatesToLocalString,
  };
}
